export const RESPONSE_HEADERS = Symbol('responseHeaders');

type WithResponseHeaders = {
    [RESPONSE_HEADERS]?: Record<string, unknown>;
};

export const getResponseHeader = (data: unknown, headerName: string): string | undefined => {
    const headers = (data as WithResponseHeaders)?.[RESPONSE_HEADERS];
    const value = headers?.[headerName.toLowerCase()];

    return typeof value === 'string' ? value : undefined;
};
